<!--
 * @Description: 表达式输入组件
 * @Author: huzhibo
 * @Email: hzbfun@gmail.com
 * @Date: 2020/11/2 10:38
 -->

<template>
  <el-input
    v-model="expression"
    :placeholder="placeholder"
    clearable
    class="expression"
    ref="expressionInput"
    maxLength="1000"
  >
    <el-popover
      placement="bottom"
      trigger="click"
      popper-class="popover-expression"
      slot="append"
    >
      <div class="expression-select">
        <!--选择字段-->
        <div class="filed">
          <div class="filed-title">
            <span>字段</span>
            <el-input v-model="filterKey">
              <template slot="append">
                <i class="e6-icon-search_line"></i>
              </template>
            </el-input>
          </div>
          <ul class="filed-list">
            <li
              v-for="(field, idx) in filterFieldList"
              :key="idx"
              @click="selectFiledOrOperate(field.conditionName)"
              class="filed-item"
            >
              {{ field.conditionName }}
            </li>
          </ul>
        </div>
        <!--选择操作符-->
        <div class="operate">
          <span class="operate-title">运算</span>
          <ul class="operate-list">
            <li
              v-for="(operate, idx) in operateList"
              :key="idx"
              @click="selectFiledOrOperate(operate)"
              class="operate-item"
            >
              {{ operate }}
            </li>
          </ul>
        </div>
      </div>
      <el-button icon="e6-icon-more_fill" slot="reference" />
    </el-popover>
  </el-input>
</template>

<script>
export default {
  name: "expression",
  inject: ["selectListCollection"],

  props: {
    value: String,
    placeholder: String
  },

  data() {
    return {
      filterKey: "",
      operateList: ["+", "-", "*", "/", "()"]
    };
  },

  computed: {
    defineIdList: vm => vm.selectListCollection.defineIdList,
    // 表达式的值
    expression: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      }
    },

    // 过滤后的列表
    filterFieldList() {
      const { filterKey, defineIdList } = this;

      if (filterKey === "") return defineIdList;
      else return defineIdList.filter(v => v.conditionName.includes(filterKey));
    }
  },

  methods: {
    // 获取关闭位置
    getPosition(el) {
      let cursorPos = 0;
      if (document.selection) {
        //IE
        var selectRange = document.selection.createRange();
        selectRange.moveStart("character", -el.value.length);
        cursorPos = selectRange.text.length;
      } else if (el.selectionStart || el.selectionStart === 0) {
        cursorPos = el.selectionStart;
      }
      return cursorPos;
    },

    // 设置光标位置
    setCaretPosition(el, pos) {
      if (el.setSelectionRange) {
        // IE Support
        el.focus();
        el.setSelectionRange(pos, pos);
      } else if (el.createTextRange) {
        // Firefox support
        var range = el.createTextRange();
        range.collapse(true);
        range.moveEnd("character", pos);
        range.moveStart("character", pos);
        range.select();
      }
    },

    selectFiledOrOperate(key) {
      const { $el, getPosition, setCaretPosition, expression } = this;
      const input = $el.querySelector(".el-input__inner"); // 获取DOM
      const pos = getPosition(input); // 获取当前光标位置
      this.expression = expression.slice(0, pos) + key + expression.slice(pos); // 拼接字符串
      const newPos = key === "()" ? pos + key.length - 1 : pos + key.length; // 新的光标位置，如是括号则放入括号内部
      setTimeout(setCaretPosition, 0, input, newPos); // 设置新的光标位置
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~e6-module-settle-accounts-center/assets/styles/billingRule.scss";
</style>

<style lang="scss">
@import "~e6-base-carrier-3.0/styles/utils";
.popover-expression {
  padding: 0;
  min-width: 316px;
  width: 316px;

  .expression-select {
    display: flex;
    width: 316px;
    height: 325px;

    /*选择字段*/
    .filed {
      box-sizing: border-box;
      width: 219px;
      border-right: 1px solid #e6ebf2;

      &-title {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 52px;
        background: #fafbfc;

        > span {
          margin-right: 15px;
          font-size: 12px;
          color: #48494c;
          white-space: nowrap;
        }

        /deep/ .el-input {
          width: 160px;

          &__inner {
            height: 32px;
          }

          .el-input-group__append {
            padding: 0 10px;
            cursor: pointer;

            .e6-icon-search_line {
              font-size: 16px;
            }
          }
        }
      }

      &-list {
        width: 100%;
        height: 272px;
        overflow-y: auto;
      }

      &-item {
        padding: 0 10px;
        line-height: 30px;
        height: 30px;
        width: 170px;
        font-size: 12px;
        color: #48494c;
        @include utils-ellipsis;
        cursor: pointer;

        &:hover {
          color: #46bfea;
        }
      }
    }

    /*选择操作符*/
    .operate {
      box-sizing: border-box;
      flex: 1;

      &-title {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 52px;
        background: #fafbfc;
      }

      &-list {
        width: 100%;
        height: 272px;
        overflow-y: auto;
      }

      &-item {
        padding: 0 10px;
        line-height: 36px;
        height: 36px;
        font-size: 24px;
        color: #48494c;
        @include utils-ellipsis;
        cursor: pointer;
        text-align: center;

        &:hover {
          color: #46bfea;
        }
      }
    }
  }
}
</style>
